/**
 * @generated SignedSource<<c6511754e01d83318b5bfe043ab5d715>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type leadDetails_leadClaimData$data = {
  readonly claimedBy: {
    readonly id: string;
  } | null;
  readonly id: string;
  readonly " $fragmentType": "leadDetails_leadClaimData";
};
export type leadDetails_leadClaimData$key = {
  readonly " $data"?: leadDetails_leadClaimData$data;
  readonly " $fragmentSpreads": FragmentRefs<"leadDetails_leadClaimData">;
};

import leadDetailsClaimDataRefreshQuery_graphql from './leadDetailsClaimDataRefreshQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": leadDetailsClaimDataRefreshQuery_graphql,
      "identifierField": "id"
    }
  },
  "name": "leadDetails_leadClaimData",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "claimedBy",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Lead",
  "abstractKey": null
};
})();

(node as any).hash = "dde972bea345aa8b61201365a1cdcc99";

export default node;
